import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EMRService } from 'app/EMR/EMR.service';
import { MedicineTemplateComponent } from 'app/EMR/template_help/medicine-template/medicine-template.component';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Observable, Subject, fromEvent, interval } from 'rxjs';
import { exhaustMap, take, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-current-medication',
  templateUrl: './current-medication.component.html',
  styleUrls: ['./current-medication.component.scss']
})
export class CurrentMedicationComponent implements OnInit {
  destroycurrentm$: Subject<boolean> = new Subject<boolean>();
  private enabledisablebtn: boolean = false;

  filteredOptions: Observable<string[]>;

  private drugAllergy: any;
  private titledose: any;
  constructor(private emrservice: EMRService,
    private datePipe: DatePipe,
    private opdvisitService: OpdVisitService,
    private dialog: MatDialog, private dashboardService: DashboardService) { }

  ngOnInit(): void {

    this.drugAllergy = '';
    this.enabledisablebtn = true;
    this.GetDosageMaster(0, 0, 0);
    this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    // this.getSite();

    this.emrservice.enabledisableVision = true;
  }
  ngOnDestroy() {
    this.destroycurrentm$.next(true);
    this.destroycurrentm$.unsubscribe();
    this.dosedataArray = null;
    this.deleateArray = null;
  }
  ngAfterViewInit(): void {

    fromEvent(this.button.nativeElement, 'click')
      .pipe(
        tap((x) => this.enabledisablebtn = true),
        exhaustMap((ev) => {
          return this.createUser();
        })
      )
      .subscribe(this.handleResponse());
  }
  @ViewChild('presentComplaintBtn', { static: true }) button;
  clicks$: Observable<any>;
  createUser(): Observable<any> {
    return interval(500).pipe(take(1));

  }
  handleResponse(): any {
    return {
      next: (res) => {
        this.insertCureentmedication()
      },
      error: (err) => {

      },

    };
  }

  dosedataArray: any = [];
  GetDosageMaster(doseid, type, seachtype) {

    this.emrservice.GetDosageMaster(doseid, type, seachtype).pipe(takeUntil(this.destroycurrentm$)).subscribe(item => {
      this.dosedataArray = [];
      this.dosedataArray = item;

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  // getSite() {
  //   this.emrservice.getMasterSite().subscribe(data => {
  //     this.sitelist = data;

  //   })
  // }
  getCurrentMedication() {

    this.emrservice.GetOpdCurrentMedication(this.emrservice.visitid).pipe(takeUntil(this.destroycurrentm$)).subscribe((x: any) => {

      if (x.length > 0) {
        this.emrservice.medinicationMainArray = [];
        x.forEach(item => {
          this.emrservice.medinicationMainArray.push({
            "pK_TranId": item.pK_TranId,
            "visitid": item.fK_VisitId,
            "medicationType": item.medicationType,
            "medicineName": item.medicineName,
            "dosageCode": item.dosageCode,
            "site": item.eye,
            "remarks": item.remarks,
            "fK_DosageId": item.fK_DosageId,
            "pK_MedicineId": item.fK_MedicineId,
            "dosageDescription": item.dosageDescription,
            "isEdit": false,
            "IsDeleted": false,
          });
        });
        this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
      }else{
        this.emrservice.mediciation_dss.data =[];
      }

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  OpenMediniceTemplate() {
    if (this.emrservice.currentMPermission?.isAddPermission == true) {
    const dialogRef = this.dialog.open(MedicineTemplateComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      maxHeight: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroycurrentm$)).subscribe(result => {

      if (result.length > 0) {
        this.enabledisablebtn = false;
        result.map(item => item.medicationType = 'S');
        this.emrservice.medinicationMainArray = this.emrservice.medinicationMainArray.concat(result);
        this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
      }
    });
  } else{
    this.dashboardService.openSnackBar("Add permission denied", "OK");
  }
  }
  onDosechange(e: any, index: number) {
    if (e != null) {

      let doseid = this.dosedataArray.filter(item => item.dosageCode == e);
      this.emrservice.medinicationMainArray[index].fK_DosageId = doseid[0].pK_DosageId;
      this.emrservice.medinicationMainArray[index].dosageCode = e;
      this.titledose = doseid[0].dosageDescription;
      this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    }
  }
  onSitechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.medinicationMainArray[index].site = e;
      this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    }
  }
  ontypechange(e: any, index: number) {
    if (e != null) {
      this.emrservice.medinicationMainArray[index].medicationType = e;
      this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    }
  }
  onremarkschange(e: any, index: number) {
    if (e != null) {
      this.emrservice.medinicationMainArray[index].remarks = e;
      this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    }
  }
  Editdata(index: number) {
    this.enabledisablebtn = false;
    this.emrservice.medinicationMainArray[index].isEdit = true;
    this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
  }
  saveEdit(item, index: number) {
    this.emrservice.medinicationMainArray[index].isEdit = false;
    this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    let medicinepayloadarray = [];
    //  let editpayload;
    // let editlist = this.editCache[id].data;    
    // if(this.emrservice.medinicationMainArray.length >0 || this.deleateArray.length >0){
    // if(this.deleateArray.length >0){
    //  this.emrservice.medinicationMainArray=  this.emrservice.medinicationMainArray.concat(this.deleateArray);
    // }
    medicinepayloadarray.push({
      "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
      "FK_VisitId": item.visitid ? item.visitid : this.emrservice.visitid,
      "MedicationType": item.medicationType,
      "FK_MedicineId": item.pK_MedicineId,
      "FK_DosageId": item.fK_DosageId,
      "PK_SynchId": null,
      "Eye": item.site ? item.site : null,
      "Remarks": item.remarks ? item.remarks : null,
      "IsEdit": item.pK_TranId == 0 ? false : true,
      "IsDelete": false
    });
    let payload = {
      "OpdCurrentMedicationDetail": medicinepayloadarray
    }
    this.emrservice.InsertOpdCurrentMedication(payload).pipe(takeUntil(this.destroycurrentm$)).subscribe((x: any) => {
      if (x['statusCode'] == 10) {
        this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
        this.getCurrentMedication();
      } else {
        this.enabledisablebtn = true;
        this.emrservice.medinicationMainArray = [];
        this.deleateArray = [];
        this.getCurrentMedication();
        this.emrservice.getPExamStatus();
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      }

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
    //  }
  }
  deleateArray: any = [];
  deletemedicine(row: any) {
    // const index: number = this.emrservice.medinicationMainArray.indexOf(row);
    // if (index !== -1) {
    //   this.enabledisablebtn =false;
    //    if(row.pK_TranId ==0){
    //     this.emrservice.medinicationMainArray.splice(index, 1);
    //     this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    //    }else{
    //     this.emrservice.medinicationMainArray.splice(index, 1);
    const index: number = this.emrservice.medinicationMainArray.indexOf(row);
    if (index !== -1) {
      this.enabledisablebtn = false;      
      if (!row.pK_TranId || row.pK_TranId === 0) {
        this.emrservice.medinicationMainArray.splice(index, 1);
        this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
        return; 
      }
    }
    if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
      // this.emrservice.open_loader_Dialog();
      let payloadArray = [];
      payloadArray.push({
        "PK_TranId": row.pK_TranId,
        "FK_VisitId": row.visitid ? row.visitid : this.emrservice.visitid,
        "MedicationType": row.medicationType,
        "FK_MedicineId": row.pK_MedicineId,
        "FK_DosageId": row.fK_DosageId,
        "PK_SynchId": null,
        "Eye": row.site,
        "Remarks": row.remarks,
        "IsEdit": true,
        "IsDelete": true
      });

      let payload = {
        "OpdCurrentMedicationDetail": payloadArray
      }
      this.emrservice.InsertOpdCurrentMedication(payload).pipe(takeUntil(this.destroycurrentm$)).subscribe((x: any) => {
        this.enabledisablebtn = true;
        this.emrservice.medinicationMainArray = [];
        this.deleateArray = [];
        this.getCurrentMedication();
        this.emrservice.getPExamStatus();
        this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar("Visit ID Not Found", "OK");
    }
    //  this.emrservice.mediciation_dss = new MatTableDataSource(this.emrservice.medinicationMainArray.slice());
    //  }

    // }

  }
  insertCureentmedication() {
    if (this.emrservice.medinicationMainArray.length > 0 || this.deleateArray.length > 0) {
      
      var drMedicinedata = [];
      if (this.deleateArray.length > 0) {
        this.emrservice.medinicationMainArray = this.emrservice.medinicationMainArray.concat(this.deleateArray);
      }
      this.emrservice.medinicationMainArray.forEach(item => {
        drMedicinedata.push({
          "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
          "FK_VisitId": this.emrservice.visitid,
          "MedicationType": item.medicationType,
          "FK_MedicineId": item.pK_MedicineId,
          "FK_DosageId": item.fK_DosageId,
          "PK_SynchId": null,
          "Eye": item.site ? item.site : null,
          "Remarks": item.remarks ? item.remarks : null,
          "IsEdit": item.pK_TranId == 0 ? false : true,
          "IsDelete": item.IsDeleted ? item.IsDeleted : false

        });
      });
      let payload = {
        "OpdCurrentMedicationDetail": drMedicinedata
      }
      this.emrservice.InsertOpdCurrentMedication(payload).pipe(takeUntil(this.destroycurrentm$)).subscribe((x: any) => {
        
        if (x['statusCode'] == 10) {
          this.enabledisablebtn = false;
          this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
          this.getCurrentMedication();
        } else {
          this.enabledisablebtn = true;
          this.emrservice.medinicationMainArray = [];
          this.deleateArray = [];
          this.getCurrentMedication();
          this.emrservice.getPExamStatus();
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        }
      }, err => {
        this.enabledisablebtn = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }

  }
 
  transferCurrMedicine(){
    this.emrservice.GetDischargeOrDoctorPrescriptionDetail(this.opdvisitService.patientdetails.pkRegId).pipe(takeUntil(this.destroycurrentm$)).subscribe((rescuu:any)=>{
      if(rescuu.length > 0){
          const currnewMedicines = [];
          rescuu.forEach((item) => {
            const exists = this.emrservice.medinicationMainArray.some(
              (obj) =>
                obj.medicineName?.trim().toLowerCase() === item.medicineName?.trim().toLowerCase() &&
                obj.dosageCode?.trim().toLowerCase() === item.dosageCode?.trim().toLowerCase() &&
                (obj.site?.trim().toLowerCase() === item.eye?.trim().toLowerCase() ||
                  obj.eye?.trim().toLowerCase() === item.eye?.trim().toLowerCase() )
            );
            if (!exists) {
              currnewMedicines.push({
              alterNateMedicine:null,
              days:item.days,
              dosageCode: item.dosageCode,
              fK_DosageId: item.fK_DosageId,
              fK_RouteId: item.fK_RouteId,
              medicationType:'S',
              fk_itemid: null,
              isDelete: null,
              isEdit: true,
              eye:item.eye,
              medicineName:item.medicineName,
              pK_MedicineId: item.fK_MedicineId,
              pK_SynchId: null,
              pK_TranId: 0,
              qty: item.qty,
              qtyUnit: item.unitQty,
              remarks: item.remarks,
              route: item.routeName,
              });
            }
          });
      
          this.emrservice.medinicationMainArray.push(...currnewMedicines);
          this.emrservice.mediciation_dss.data = [...this.emrservice.medinicationMainArray]; 
          this.enabledisablebtn = false;

      }else{
        this.dashboardService.openSnackBar("No Record Found", "OK");
      }
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error && err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }




  // transferCurrMedicine() {
  //   this.priviousMedicine();
  //   if (this.storPriviousmedicineArray.length > 0) {
  //     const currnewMedicines = [];
  //     this.storPriviousmedicineArray.forEach((item) => {
  //       const exists = this.emrservice.medinicationMainArray.some(
  //         (obj) =>
  //           obj.medicineName?.trim().toLowerCase() === item.medicineName?.trim().toLowerCase() &&
  //           obj.dosageCode?.trim().toLowerCase() === item.dosageCode?.trim().toLowerCase() &&
  //           obj.eye?.trim().toLowerCase() === item.eye?.trim().toLowerCase()
  //       );
  //       if (!exists) {
  //         currnewMedicines.push({
  //         alterNateMedicine:null,
  //         days:item.days,
  //         dosageCode: item.dosageCode,
  //         fK_DosageId: item.fK_DosageId,
  //         fK_RouteId: item.fK_RouteId,
  //         fk_itemid: null,
  //         isDelete: null,
  //         isEdit: true,
  //         eye:item.eye,
  //         medicineName:item.medicineName,
  //         pK_MedicineId: item.fK_MedicineId,
  //         pK_SynchId: null,
  //         pK_TranId: 0,
  //         qty: item.qty,
  //         qtyUnit: item.unitQty,
  //         remarks: item.remarks,
  //         route: item.routeName,
  //         });
  //       }
  //     });
  
  //     this.emrservice.medinicationMainArray.push(...currnewMedicines);
  //     this.emrservice.mediciation_dss.data = [...this.emrservice.medinicationMainArray]; 
  //     this.enabledisablebtn = false;
  //   } else {
  //     this.dashboardService.openSnackBar("No Record Found", "OK");
  //   }
  // }
}
